import React, { useState, useEffect } from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { fetchNewPatients } from "../../services/newPatientsService";
import UpdateAcquisition from "../calls/updateAcquisition";
import { useAppSelector } from "../../store/hook";
import ReconcileApprovalModal from "../calls/reconcileModal";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import CommentModal from "./commentModal";
import { Modal } from "react-bootstrap";
import ConclusionModal from "./ConclusionModal";

interface NewPatient {
  id: number;
  name: string;
  date: string;
  source: string;
  hasRecording: boolean;
  value: number;
}

type Props = {
  isPrintMode: boolean;
  clinicUniqueId: string;
  dateFilter: { startDate: string; endDate: string };
};

const NewPatientsSection = ({
  isPrintMode,
  clinicUniqueId,
  dateFilter,
}: Props) => {
  const clinics = useAppSelector((state) => state.user.user.clinics);
  const clinicDatax = clinics?.find(
    (item: any) => item.uniqueId === clinicUniqueId
  );
  const [rows, setRows] = useState<NewPatient[]>([]);
  const [open1, setOpen1] = useState(false);
  const [openConclusion, setOpenConclusion] = useState(false);
  const [parsedConclusion, setParsedConclusion] = useState<any>(null);
  const [commentData, setCommentData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isModalOpenReconcile, setIsModalOpenReconcile] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpenAcquisition, setIsModalOpenAcquisition] = useState(false);
  const [reconcileData, setReconcileData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const fetchData = async () => {
    try {
      const res = await fetchNewPatients({
        clinicUniqueId,
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate,
      });
      if (res?.status?.msg === "Success") {
        setRows(
          res?.list?.map((x: any, i: number) => ({
            ...x,
            name: `${x?.fname} ${x?.lname}`,
            srNo: i + 1,
            id: x?.id,
            // id: i + 1,
          }))
        );
      }
    } catch (err) {
      setError("Failed to fetch new patients data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (clinicUniqueId && dateFilter?.startDate && dateFilter?.endDate) {
      fetchData();
    }
  }, [clinicUniqueId, dateFilter]);

  const handleRecordingClick = (id: number) => {
    alert(`Play recording for patient ID: ${id}`);
  };

  const renderSource = (source: string, hasRecording: boolean, id: number) => {
    switch (source) {
      case "Call":
        return (
          <span>
            {" "}
            {hasRecording && (
              <span
                onClick={() => handleRecordingClick(id)}
                style={{ cursor: "pointer" }}
                title="Click to listen to recording"
              >
                {" "}
              </span>
            )}
          </span>
        );
      case "Booking":
        return <span> </span>;
      case "Rewards":
        return <span> </span>;
      case "Referral":
        return <span> </span>;
      default:
        return source;
    }
  };
  // const columns: Column[] = [
  //   {
  //     field: "srNo",
  //     headerName: "#",
  //     width: "5%",
  //     renderCell: (row: any) => (
  //       <span className="text-[11px] sm: md:text-sm">{row.srNo}</span>
  //     ),
  //   },
  //   {
  //     field: "name",
  //     headerName: "Patient Name",
  //     minWidth: "15%",
  //     renderCell: (row: any) => (
  //       <span className="truncate max-w-[100px] sm:max-w-[160px] md:max-w-[200px] text-[11px] sm:text-xs md:text-sm">
  //         {row.name}
  //       </span>
  //     ),
  //   },
  //   {
  //     field: "phone",
  //     headerName: "Phone",
  //     width: "10%",
  //     renderCell: (row: any) => (
  //       <span className="truncate text-[11px] sm:text-xs md:text-sm">
  //         {row.phone}
  //       </span>
  //     ),
  //   },
  //   {
  //     field: "email",
  //     headerName: "Email",
  //     minWidth: "15%",
  //     renderCell: (row: any) => (
  //       <span className="truncate max-w-[120px] sm:max-w-[200px] text-[11px] sm:text-xs md:text-sm">
  //         {row.email}
  //       </span>
  //     ),
  //   },
  //   {
  //     field: "source",
  //     headerName: "Source",
  //     minWidth: "10%",
  //     renderCell: (row: any) => (
  //       <span className="truncate text-[11px] sm:text-xs md:text-sm">
  //         {row.source}
  //       </span>
  //     ),
  //   },
  //   {
  //     field: "notes",
  //     headerName: "Reason",
  //     minWidth: "20%",
  //     renderCell: (row: any) => (
  //       <span className="break-words text-[11px] sm:text-xs md:text-sm leading-snug">
  //         {row.notes}
  //       </span>
  //     ),
  //   },
  //   {
  //     field: "status",
  //     headerName: "Status",
  //     minWidth: "15%",
  //     renderCell: (row: any) => {
  //       const reconcileValue = row.reconcile;
  //       let data = null;

  //       if (reconcileValue) {
  //         try {
  //           data =
  //             typeof reconcileValue === "string"
  //               ? JSON.parse(reconcileValue)
  //               : reconcileValue;
  //         } catch {
  //           console.error("Invalid JSON:", reconcileValue);
  //         }
  //       }

  //       return (
  //         <div className="flex flex-col items-start justify-center gap-[2px] text-[11px] sm:text-xs md:text-sm">
  //           <span className="truncate">{row.status}</span>
  //           {data?.name && (
  //             <span className="text-[10px] sm:text-[11px] text-gray-600 truncate">
  //               {data.name}
  //             </span>
  //           )}
  //           {data?.date && (
  //             <span className="text-[10px] sm:text-[11px] text-gray-600 truncate">
  //               {data.date}
  //             </span>
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     field: "action",
  //     headerName: "Action",
  //     width: "10%",
  //     renderCell: (row: any) => (
  //       <div className="flex justify-center items-center h-full">
  //         <button
  //           onClick={(e) => {
  //             e.stopPropagation();
  //             setSelectedRow({ ...row, newStatus: row?.status });
  //             setIsModalOpenAcquisition(true);
  //           }}
  //           className="px-2 py-[2px] sm:py-1 text-[10px] sm:text-xs md:text-sm rounded bg-[#4CC9C0] text-white hover:opacity-90 whitespace-nowrap"
  //         >
  //           📋 Update
  //         </button>
  //       </div>
  //     ),
  //   },
  // ];

  const totalValue = rows.reduce((acc, row) => acc + row.value, 0);

  if (loading) {
    return <div className="bg-white p-6 rounded-lg shadow-md">Loading...</div>;
  }

  // if (error) {
  //   return <div className="bg-white p-6 rounded-lg shadow-md">Error: {error}</div>;
  // }

  const statusBodyTemplate = (rowData: any) => {
    let data: any = null;
    if (rowData.reconcile) {
      try {
        data =
          typeof rowData.reconcile === "string"
            ? JSON.parse(rowData.reconcile)
            : rowData.reconcile;
      } catch {
        console.error("Invalid JSON:", rowData.reconcile);
      }
    }

    return (
      <div className="flex flex-col items-start gap-[2px] text-xs">
        <span>{rowData.status}</span>
        {data?.name && <span className="text-gray-600">{data.name}</span>}
        {data?.date && <span className="text-gray-600">{data.date}</span>}
      </div>
    );
  };

  const actionBodyTemplate = (rowData: any) => {
    const hasConclusion = (conclusion: any) => {
      if (!conclusion) return false;
      if (conclusion === "null") return false;

      try {
        const parsed =
          typeof conclusion === "string" ? JSON.parse(conclusion) : conclusion;

        return parsed && Object.keys(parsed).length > 0;
      } catch {
        return false;
      }
    };

    return (
      <div className="flex justify-center">
        <button
          className="px-2 py-1 text-xs rounded bg-[#4CC9C0] text-white whitespace-nowrap min-w-[80px] hover:opacity-90"
          onClick={(e: any) => {
            e.stopPropagation();
            console.log("Row clicked:", rowData);
            setSelectedRow({ ...rowData, newStatus: rowData?.status });
            setIsModalOpenAcquisition(true);
          }}
        >
          📋 Update
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setOpen1(true);
            setCommentData({
              ...rowData,
              ...rowData?.matchedPatient,
              comment: rowData?.comment,
            });
          }}
          className="px-2 text-xs rounded"
          // style={{
          //   padding: "2px 8px",
          //   marginTop: "10px",
          //   backgroundColor: "#E0E0E0",
          //   border: "none",
          // }}
        >
          <i className="bi bi-info-circle"></i>
        </button>
        {hasConclusion(rowData?.conclusion) ? (
          <button
            className="btn btn-link p-0"
            onClick={() => {
              setOpenConclusion(true);
              setParsedConclusion(rowData?.conclusion);
            }}
          >
            <i className="bi bi-clipboard-check text-black"></i>
          </button>
        ) : (
          ""
        )}
      </div>
    );
  };

  const truncateCell = (value: string) => (
    <div title={value} className="truncate-cell">
      {value}
    </div>
  );

  return (
    <>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-[#194e5b] mb-2">
          New Patients Acquisition
        </h2>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-[#194e5b]">
            New Patients Acquired
          </h3>
          <div className="text-lg font-semibold text-gray-700">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsModalOpenReconcile(true);
              }}
              disabled={reconcileData.length === 0}
              className="btn btn-sm btn-secondary"
              style={{
                padding: "5px 10px",
                marginTop: "10px",
                backgroundColor: "#4CC9C0",
                border: "none",
              }}
            >
              {" "}
              Reconcile
            </button>
            {/* Total Value: ${totalValue.toLocaleString()} */}
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <DataTable
            value={rows}
            size="large"
            showGridlines
            stripedRows
            tableStyle={{ minWidth: "100%", borderCollapse: "collapse" }}
            selectionMode="checkbox"
            selection={selectedRows}
            onSelectionChange={(e: any) => {
              setSelectedRows(e.value);
              setReconcileData(
                e.value?.map((x: any) => ({
                  acquType: x?.acquType,
                  id: x?.id,
                }))
              );
            }}
            className="custom-table"
            dataKey="id" // ✅ important for checkbox selection
          >
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "3rem", textAlign: "center" }}
              bodyStyle={{
                textAlign: "center",
                verticalAlign: "middle",
                padding: "8px",
              }}
            />
            <Column
              field="srNo"
              header="Sr No"
              style={{
                width: "5%",
                whiteSpace: "nowrap", // 🔹 prevents wrapping
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
            <Column
              field="name"
              header="Name"
              style={{ maxWidth: "100%", fontWeight: 500 }}
            />
            <Column
              field="phone"
              header="Phone"
              style={{
                minWidth: "150px",
                maxWidth: "160px",
                whiteSpace: "nowrap", // 🔹 single line
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontWeight: 500,
              }}
            />
            <Column
              field="email"
              header="Email"
              style={{
                minWidth: "160px",
                maxWidth: "220px",
                whiteSpace: "nowrap", // 🔹 single line
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />

            <Column
              field="source"
              header="Source"
              style={{ minWidth: "10%", textTransform: "capitalize" }}
            />
            <Column
              field="notes"
              header="Reason"
              style={{
                minWidth: "10%", // 🔹 reduced further
                maxWidth: "140px", // 🔹 tighter cap
                whiteSpace: "normal", // 🔹 Reason can wrap
                wordBreak: "break-word",
                lineHeight: "1.5",
              }}
            />

            <Column
              field="status"
              header="Status"
              body={statusBodyTemplate}
              style={{
                minWidth: "10%",
                fontWeight: 500,
              }}
            />
            <Column
              header="Action"
              body={actionBodyTemplate}
              style={{
                width: "10%",
                textAlign: "center",
              }}
            />
          </DataTable>

          <style jsx global>{`
            .p-datatable.custom-table {
              border-radius: 10px;
              overflow: hidden;
              box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
              font-size: 14px;
            }

            .p-datatable.custom-table .p-datatable-thead > tr > th {
              background: #f9fafb;
              font-weight: 600;
              color: #111827;
              padding: 6px 8px;
              border-bottom: 1px solid #e5e7eb;
              white-space: nowrap;
              vertical-align: middle;
            }

            .p-datatable.custom-table .p-datatable-tbody > tr > td {
              padding: 6px 8px;
              border-bottom: 1px solid #e5e7eb;
              vertical-align: middle;
              white-space: normal;
              word-break: break-word;
            }

            .p-datatable.custom-table .p-datatable-thead > tr > th,
            .p-datatable.custom-table .p-datatable-tbody > tr > td {
              padding: 6px 8px;
            }

            /* Add border around checkboxes */
            .p-datatable.custom-table .p-checkbox .p-checkbox-box {
              border: 1px solid #cbd5e0;
              border-radius: 4px;
            }

            .p-datatable.custom-table
              .p-checkbox:not(.p-checkbox-disabled)
              .p-checkbox-box.p-focus {
              box-shadow: 0 0 0 0.2rem rgba(25, 78, 91, 0.25);
              border-color: #194e5b;
            }

            .p-datatable.custom-table
              .p-checkbox:not(.p-checkbox-disabled)
              .p-checkbox-box.p-highlight {
              border-color: #194e5b;
              background: #194e5b;
            }

            .p-datatable.custom-table .p-datatable-tbody > tr:last-child > td {
              border-bottom: none;
            }

            .p-datatable-wrapper {
              overflow-x: hidden !important;
              overflow-y: hidden !important;
            }

            @media (max-width: 768px) {
              .p-datatable.custom-table {
                font-size: 12px;
              }
            }
          `}</style>
          {/* <DataTable
            columns={columns}
            rows={rows}
            selectable
            // pagination
            onSelectionChange={(selectionModel: any) => {
              setReconcileData(
                selectionModel?.map((x: any) => ({
                  acquType: x?.acquType,
                  id: x?.id,
                }))
              );
            }}
          /> */}
        </div>
      </div>
      <UpdateAcquisition
        open={isModalOpenAcquisition}
        onClose={() => setIsModalOpenAcquisition(false)}
        clinicData={clinicDatax}
        dateFilter={dateFilter}
        initialData={selectedRow}
        onSave={fetchData}
      />
      <ReconcileApprovalModal
        onStart={(adminName: string) => {
          console.log(adminName);
        }}
        open={isModalOpenReconcile}
        onClose={() => setIsModalOpenReconcile(false)}
        clinicData={clinicDatax}
        dateFilter={dateFilter}
        initialData={selectedRow}
        onSave={() => {
          fetchData();
          setReconcileData([]);
        }}
        reconcileData={reconcileData}
      />
      <CommentModal
        onClose={() => {
          setOpen1(false);
          setCommentData({});
        }}
        data={commentData}
        open={open1}
        clinicData={clinicUniqueId}
        refetchApi={fetchData}
        api="acqcommentupdate"
      />
      <ConclusionModal
        open={openConclusion}
        onClose={() => setOpenConclusion(false)}
        conclusion={parsedConclusion}
      />
    </>
  );
};

export default NewPatientsSection;
